export default __webpack_public_path__ + "images/default-8e5ac0eaca35d68cea2ec70b6ac74d35.jpg";